/* eslint-disable jsx-a11y/alt-text */
import "./Technologies.css";
import Skill from "../Skill/Skill";
import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Technologies() {
  const [skill, setSkill] = useState<JSX.Element>();
  useEffect(() => {
    AOS.init({ once: true, duration: 1500 });
  }, []);
  return (
    <div className="technologies" data-aos="fade-up">
      <div className="technolgies-content">
        <div className="sub-title text-5xl md:text-7xl text-center mb-10 mt-40">
          Technologies
          <p className="text-2xl italic font-semibold">I am using</p>
        </div>
        <div className="hr w-2/3"></div>
        <div className="techs flex flex-col lg:flex-row px-2 md:mx-auto md:w-2/3 w-full lg:space-x-10 lg:space-y-0 space-y-10 space-x-0">
          <div className="left grow shrik basis-0 grid gap-x-3 gap-y-3 place-items-center justify-center">
            <img
              src="https://img.icons8.com/ios/100/00d9ff/react-native--v1.png"
              onClick={() => {
                const skill_ = <Skill name="React" level={4} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/color/100/000000/firebase.png"
              onClick={() => {
                const skill_ = <Skill name="Firebase" level={2} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/color/100/000000/typescript.png"
              onClick={() => {
                const skill_ = <Skill name="Typescript" level={3} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/color/100/000000/javascript--v1.png"
              onClick={() => {
                const skill_ = <Skill name="Javascript" level={4} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/color/100/000000/python--v1.png"
              onClick={() => {
                const skill_ = <Skill name="Python" level={5} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/ios/100/d91100	/flask.png"
              onClick={() => {
                const skill_ = <Skill name="Flask" level={4} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/ios-filled/100/a06dda/c-sharp-logo.png"
              onClick={() => {
                const skill_ = <Skill name="C# .NET" level={3} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/color/100/000000/html-5--v1.png"
              onClick={() => {
                const skill_ = <Skill name="HTML5" level={5} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/color/100/000000/css3.png"
              onClick={() => {
                const skill_ = <Skill name="CSS3" level={5} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/color/100/000000/angularjs.png"
              onClick={() => {
                const skill_ = <Skill name="Angular" level={3} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/dusk/100/000000/c-plus-plus.png"
              onClick={() => {
                const skill_ = <Skill name="C++" level={4} />;
                setSkill(() => skill_);
              }}
            />
            <img
              src="https://img.icons8.com/dusk/100/000000/docker.png"
              onClick={() => {
                const skill_ = <Skill name="Docker" level={4} />;
                setSkill(() => skill_);
              }}
            />
          </div>
          <div className="right grow shrink basis-0">
            <p className="text-3xl underline mb-5 text-center lg:text-left">
              My skills
            </p>
            {skill ? skill : ""}
            <p className="leading-8 ml-2 text-justify">
              You can see the skills what I have earnt during the years, and the
              technologies I know so far. I am able to say, the learning phase
              for each <b>framework/language</b> learn-difficulty could be
              defined by snowball effect. The first language was C#. The last
              was React. There was a huge difference betweeen the way I learn
              both. The experience is a huge odds for each now language/tech.
              <br />
              <i className="font-semibold">
                The more you learn, the more easier would be the next
              </i>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
